document.addEventListener("alpine:init", () => {
  Alpine.data(
    "Theme_Slideshow",
    ({
      autoplay = false,
      autoplayInterval = null,
      mode = "slideshow",
      gap = null,
      onlyIfNeeded = false,
      options = {},
      pagination = true,
    }) => ({
      autoplay,
      autoplayInterval,
      playing: false,
      splide: null,
      options,
      rate: 0,
      pagination,
      mode,
      gap,
      onlyIfNeeded,
      swiperEl: null,
      maxLgBreakpointMQL: window.matchMedia("(max-width: 1023px)"),
      init(){
        if(this.$refs.swiperEl){
          this.swiperEl = this.$refs.swiperEl;
        }else{
          this.swiperEl = this.$root;
        }
        this.initSlideshow();
      },
      initSlideshow() {
        if (typeof Swiper === "undefined") {
          console.error(
            "slideshows-v2.js requires a Swiper object to be defined in the global scope"
          );

          return;
        }

        this.initSwiper();
        const _this = this;
        if (this.$refs.progressBar) {
          this.$root.addEventListener("move", function (evt) {
            _this.$refs.progressBar.style.width =
              evt.detail.progress.toString() + "%";
          });
        }

        if (this.onlyIfNeeded) {
          this.destroyOrInitIfNeeded();

          this.maxLgBreakpointMQL.addEventListener("change", (e) => {
            this.destroyOrInitIfNeeded();
          });
        }

        if (Shopify.designMode) {
          this._setUpDesignModeHandlers();
        }

        document.addEventListener("dev:hotreloadmutation", async () => {
          if (!Shopify.designMode) {
            this.swiper.destroy();

            await this.$nextTick();

            this.initSwiper();
          }
        });
      },
      initSwiper() {
        if(this.swiper){
          this.swiper.init(this.swiperEl);
        }
        const options = {
          ...this.options,
          spaceBetween: this.gap,
        };
        if (this.pagination) {
          options["pagination"] = {
            el: this.$refs.swiperPagination || this.$root.querySelector('.swiper-pagination'),
            bulletClass: 'mic-pagination-bullet',
            bulletActiveClass: 'active',
            type: 'bullets',
            clickable: true,
          };
          options['hashNavigation'] = {
            watchState: true,
          }
        }
        if (this.autoplay) {
          options["autoplay"] = {
            delay: this.autoplayInterval,
          };
        }
          
        this.swiper = new Swiper(this.swiperEl, options);

        if (options.autoplay) {
          this.swiper.on("autoplayStart", () => {
            this.playing = true;
          });
          this.swiper.on("autoplayResume", () => {
            this.playing = true;
          });
          this.swiper.on("autoplayPause", () => {
            this.playing = false;
          });
          this.swiper.on("autoplayStop", () => {
            this.playing = false;
          });
          this.swiper.on("autoplayTimeLeft", (swiper, timeLeft, rate) => {
            this.rate = rate;
          });
        }
      },
      destroyOrInitIfNeeded() {
        const slideEls = Array.from(
          this.$root.querySelectorAll(".swiper-slide")
        );

        const totalSlidesWidth = slideEls.reduce(
          (totalWidth, slideEl) =>
            totalWidth + slideEl.getBoundingClientRect().width,
          0
        );

        const totalGridlinesWidth = 0;

        const totalContentWidth = totalSlidesWidth + totalGridlinesWidth;
        console.log(totalContentWidth, this.$root.getBoundingClientRect().width)
        if (totalContentWidth <= this.$root.getBoundingClientRect().width) {
          this.swiper.disable();
        } else {
            this.swiper.enable();
        }
      },
      _setUpDesignModeHandlers() {
        this.$root.addEventListener("slideshow-go", (e) => {
          if (!e.detail) return;

          this.swiper.go(parseInt(e.detail, 10));
        });
      },
    })
  );
});
